import {BoosterType} from "@/store/shop/types";

export default class BoosterUtils {

    public static getIcon(boosterType: BoosterType) {
        switch (boosterType) {
            case BoosterType.EXP_SMALL:
                return 'exp_small';
            case BoosterType.EXP_MIDDLE:
                return 'exp_middle';
            case BoosterType.EXP_BIG:
                return 'exp_big';
            case BoosterType.HEALTH_SMALL:
                return 'health_small';
            case BoosterType.HEALTH_MIDDLE:
                return 'health_middle';
            case BoosterType.HEALTH_BIG:
                return 'health_big';
            case BoosterType.RECOVER_SMALL:
                return 'recover_small';
            case BoosterType.RECOVER_MIDDLE:
                return 'recover_middle';
            case BoosterType.RECOVER_BIG:
                return 'recover_big';
            case BoosterType.COMPLEX_SMALL:
                return 'complex_small';
            case BoosterType.COMPLEX_MIDDLE:
                return 'complex_middle';
            case BoosterType.COMPLEX_BIG:
                return 'complex_big';

        }
    }
}
